<h2 style="margin-bottom:5px;font-weight:bold;font-size:1.15em">{{policyInfoService.getDisplayName(policy)}}</h2>
<article class="claims-overview-content">
    <a id="claimsList_{{policyInfoService.getDisplayName(policy)}}" class="claims-track-claim-content__link-box link-arrow-orange dark-gray-text" (click)="navigateToPolicyClaimsList()">
        <div class="mat-icon-container">
            <mat-icon svgIcon="{{policyInfoService.getDisplayName(policy)}}"></mat-icon>
        </div>
        <div class="link-text-box__content">
            <em>{{policyInfoService.getDisplayName(policy)}} claims list</em>
            <br>
            <p>{{policyNumber}}</p>
        </div>
    </a>
    <div class="claims-track-claim-content__text-box dark-gray-text">
        <div class="mat-icon-container">
            <mat-icon svgIcon="{{policyInfoService.getDisplayName(policy)}}"></mat-icon>
        </div>
        <div class="flexing">
            <div class="intro-p">
                <em>Start a
                    <span style="text-transform: lowercase">{{policyInfoService.getDisplayName(policy)}}</span>
                    claim</em>
                <br>
                <p>Filing your claim only takes a few minutes.</p>
            </div>
            <div class="intro-p-button">
                <button id="Btn_{{policyInfoService.getDisplayName(policy)}}" (click)="fileAClaim()" class="button preferred">Start
                    a
                    <span style="text-transform: lowercase">{{policyInfoService.getDisplayName(policy)}}</span>
                    claim</button>
            </div>
        </div>
    </div>

    <div class="claims-track-claim-content__text-box  dark-gray-text" *ngIf="isAuto">
        <div class="mat-icon-container">
            <mat-icon svgIcon="glass-damage"></mat-icon>
        </div>
        <div class="flexing">
            <div class="intro-p">
                <em>Report glass damage</em>
                <br>
                <p>With Nationwide’s On Your Side® Glass Service program, repairs can be completed at your home, office
                    or a repair
                    facility, usually within 24 hours through our partner Safelite AutoGlass®.</p>
                <p>When filing your glass claim, you can use Safelite or a provider of your choice.</p>
            </div>
            <div class="intro-p-button">
                <button id="glassClaim" (click)="fileAGlassClaim()" class="button preferred">Start a glass
                    claim</button>
            </div>
        </div>
    </div>

    <div class="claims-track-claim-content__text-box dark-gray-text" *ngIf="isAuto">
        <div class="mat-icon-container">
            <mat-icon svgIcon="roadside-assistance"></mat-icon>
        </div>
        <div class="flexing">
            <em>Roadside Assistance</em>
            <br>Get on-demand help for a flat tire, jump or tow if you've signed up for Roadside Assistance. Call
            1-800-421-3535
            anytime.
        </div>
    </div>
    <ng-container *ngIf="claimsList.length>0 && claimsDataService.lossCauseTypesLoaded">
        <div class="claims-track-claim-content__text-box">
            <h2>RECENT CLAIMS</h2>
            <ng-container *ngFor="let list of claimsList | slice:0:2">
                <div id="RoadsideAssistance" *ngIf="list.lossCause == 'lockout' || list.lossCause == 'glassbreakage'" class="claims-track-claim-content__text-box dark-gray-text">
                    <div class="mat-icon-container">
                        <mat-icon svgIcon="claim"></mat-icon>
                    </div>
                    <ng-container *ngIf="list.incidentOnly">
                        <em>{{claimsDataService.getLossCause(list.lossCause)}}
                            <span class="claim-number">({{list.claimNumber}})</span> -
                            <span style="text-transform: capitalize">{{list.claimState}}</span>
                        </em> (Record Only)
                    </ng-container>

                    <ng-container *ngIf="!list.incidentOnly">
                        <em>{{claimsDataService.getLossCause(list.lossCause)}}
                            <span class="claim-number">({{list.claimNumber}})</span> -
                            <span style="text-transform: capitalize">{{list.claimState}}</span>
                        </em>
                    </ng-container>
                    <br>Incident date: {{list.lossDate| date:'MM/dd/yyyy'}}
                </div>
                <a id="claim_{{list.claimNumber}}" (click)="navigateToClaimOverview(list.claimNumber, list.premisisID)" class="claims-track-claim-content__link-box link-arrow-orange dark-gray-text"
                    style="margin-bottom:10px;padding-bottom:0" *ngIf="list.lossCause != 'lockout' && list.lossCause != 'glassbreakage'">
                    <div class="mat-icon-container">
                        <mat-icon svgIcon="claim"></mat-icon>
                    </div>
                    <ng-container *ngIf="list.incidentOnly">
                        <em>{{claimsDataService.getLossCause(list.lossCause)}}
                            <span class="claim-number">({{list.claimNumber}})</span> -
                            <span style="text-transform: capitalize">{{list.claimState}}</span>
                        </em> (Record Only)
                    </ng-container>
                    <ng-container *ngIf="!list.incidentOnly">
                        <em>{{claimsDataService.getLossCause(list.lossCause)}}
                            <span class="claim-number">({{list.claimNumber}})</span> -
                            <span style="text-transform: capitalize">{{list.claimState}}</span>
                        </em>
                    </ng-container>
                    <br>Incident date: {{list.lossDate| date:'MM/dd/yyyy'}}
                </a>
            </ng-container>
            <p *ngIf="claimsList.length>2">
                <a id="viewAll_{{policyInfoService.getDisplayName(policy)}}" (click)="navigateToPolicyClaimsList()" style="float:right">View
                    all
                    <span style="text-transform: lowercase">{{policyInfoService.getDisplayName(policy)}}</span>
                    claims</a>
            </p>
        </div>
    </ng-container>

    <ng-container *ngIf="(claimsList.length<=0)">
        <div class="claims-track-claim-content__text-box">
            <h2>RECENT CLAIMS</h2>
            <p class="claims-track-claim-content__text-box  dark-gray-text">
                There are no recent claims available to view for this policy. Closed claims with no activity for 12
                months cannot be viewed
                online.
            </p>
        </div>
    </ng-container>
</article>
